var Et = Object.defineProperty;
var mt = (r, t, e) => t in r ? Et(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var V = (r, t, e) => (mt(r, typeof t != "symbol" ? t + "" : t, e), e), et = (r, t, e) => {
  if (!t.has(r))
    throw TypeError("Cannot " + e);
};
var i = (r, t, e) => (et(r, t, "read from private field"), e ? e.call(r) : t.get(r)), a = (r, t, e) => {
  if (t.has(r))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(r) : t.set(r, e);
}, h = (r, t, e, s) => (et(r, t, "write to private field"), s ? s.call(r, e) : t.set(r, e), e);
var d = (r, t, e) => (et(r, t, "access private method"), e);
import { p as at } from "./emotion-css-create-instance.esm.js";
import { s as M, S as wt } from "./states.js";
const ft = (r) => {
  var n, u;
  const t = [], e = [], s = ((n = r.postroll) == null ? void 0 : n.length) ?? 0;
  for (let l = 0; l < s; l++) {
    const o = (u = r.postroll) == null ? void 0 : u[l];
    o && (t.push(o), o && e.push({
      adparams: o,
      mediaid: o.dailymotionId ?? "",
      title: o.title ?? ""
    }));
  }
  return {
    postrolls: t,
    playlist: e
  };
}, It = (r) => {
  if (typeof r != "string")
    return;
  const t = document.createElement("img");
  t.src = r.replace("[wads_call_master]", "1").replace("[wads_creative_master]", "1").replace("[wads_random]", String(Math.ceil(Math.random() * 1e7)));
}, Ct = (r = []) => {
  for (const t of r)
    It(t);
}, bt = (r, t = {}) => ht(r, t), Nt = (r, t, e = {}) => {
  const s = parseInt(t, 10);
  return r === "" || Number.isNaN(s) ? r : ht(Dt(r, t), e);
}, Lt = "%", St = "%", xt = "|", ht = (r, t) => {
  let e = r;
  for (const s in t)
    if (Object.prototype.hasOwnProperty.call(t, s)) {
      const n = new RegExp(St + s + Lt, "g");
      r && n.test(r) && (e = e == null ? void 0 : e.replace(n, t[s]));
    }
  return e;
}, it = (r) => r === "-Inf" ? Number.NEGATIVE_INFINITY : r === "+Inf" || r === "Inf" ? Number.POSITIVE_INFINITY : parseInt(r, 10), Dt = (r, t) => {
  const e = r.split(xt), s = /^\w+: +(.+)$/u, n = /^\s*((\{\s*(-?\d+[\s*,\-?\d+]*)\s*\})|([[\]])\s*(-Inf|-?\d+)\s*,\s*(\+?Inf|-?\d+)\s*([[\]]))\s?(.+?)$/u, u = /^\s*(\{\s*(-?\d+[\s*,\-?\d+]*)\s*\})|([[\]])\s*(-Inf|-?\d+)\s*,\s*(\+?Inf|-?\d+)\s*([[\]])/u;
  let l = null;
  const o = {}, E = [];
  for (let p = 0; p < e.length; p++) {
    const g = e[p];
    n.test(g) ? (l = g.match(n), l && (o[l[0]] = l[l.length - 1])) : s.test(g) ? (l = g.match(s), l && E.push(l[1])) : E.push(g);
  }
  for (const p in o)
    if (u.test(p))
      if (l = p.match(u), !l || l[1]) {
        if (l) {
          const g = l[2].split(",");
          let w;
          for (w in g)
            if (t.toString() === g[w])
              return o[p];
        }
      } else {
        const g = it(l[4]), w = it(l[5]), G = it(t.toString());
        if ((l[3] === "[" ? G >= g : G > g) && (l[6] === "]" ? G <= w : G < w))
          return o[p];
      }
  return E[0] || void 0;
}, Vt = 10, st = ["start", "firstQuartile", "midpoint", "thirdQuartile", "complete"];
var c, y, P, F, _, f, $, v, I, H, k, m, L, C, Q, Y, b, S, x, N, q, ot, j, ct, A, dt, X, ut, D, O, U, nt, z, gt, J, vt, K, Pt, Z, pt, R, yt, B, W;
const tt = class tt {
  constructor(t, e) {
    // End of preview UI variables
    a(this, q);
    a(this, j);
    a(this, X);
    a(this, D);
    a(this, U);
    a(this, z);
    a(this, J);
    a(this, K);
    a(this, Z);
    a(this, R);
    a(this, B);
    a(this, c, void 0);
    a(this, y, null);
    a(this, P, 0);
    a(this, F, void 0);
    a(this, _, void 0);
    a(this, f, []);
    a(this, $, !1);
    a(this, v, void 0);
    a(this, I, []);
    a(this, H, 0);
    a(this, k, 0);
    // Preview UI variables
    a(this, m, null);
    a(this, L, null);
    a(this, C, null);
    a(this, Q, -1);
    a(this, Y, window.document.createElement("div"));
    a(this, b, null);
    a(this, S, !1);
    a(this, x, !1);
    a(this, N, !1);
    h(this, c, t), h(this, v, {
      active: !1,
      // this will be modified by the postroll plugin once a postroll has been loaded
      previewMessage: "]-Inf,1]Dans %time% seconde: <br /><strong>%title%</strong>|]1,Inf]Dans %time% secondes: <br /><strong>%title%</strong>",
      titleReleaseDate: "<strong>%title%</strong>",
      ...e
    });
  }
  currentPostrollIndex() {
    return this.isPlayingPostrollVideo() ? i(this, P) - i(this, f).length : -1;
  }
  getCurrentPostroll() {
    return i(this, F);
  }
  getNextPostroll() {
    return i(this, _);
  }
  getPostrollConfig() {
    return i(this, v);
  }
  /**
   * Attach the event listener to the post-roll video once the player is ready.
   */
  initAsReady() {
    if (!i(this, y))
      throw new Error("setupPostrollAsVideoPlaylist() was not called before initAsReady()");
    h(this, P, Number.NEGATIVE_INFINITY), d(this, B, W).call(this), i(this, c).addEventListener("before-complete", () => {
      var t, e;
      (e = (t = i(this, c).banner).setLeftBanner) == null || e.call(t, null);
    }), i(this, c).addEventListener("playlist-item", ({ detail: { index: t } }) => {
      var e, s;
      h(this, P, t), h(this, S, !1), h(this, x, !1), h(this, N, !1), d(this, B, W).call(this), (s = (e = i(this, c).banner).setBottomRightBanner) == null || s.call(e, null);
    }), i(this, c).addEventListener(
      "quartile-postroll",
      (t) => {
        var e, s;
        return d(this, J, vt).call(this, (s = (e = i(this, y)) == null ? void 0 : e.postrolls) == null ? void 0 : s[this.currentPostrollIndex()], t.detail.quartile);
      }
    ), i(this, c).addEventListener("playlist-complete", () => {
      h(this, P, Number.NEGATIVE_INFINITY), h(this, S, !1), d(this, B, W).call(this);
    }), i(this, c).addEventListener("time", ({ detail: { position: t, duration: e } }) => {
      var u, l, o, E, p, g, w;
      const s = Math.floor(e - t), n = ((u = i(this, v)) == null ? void 0 : u.previewDuration) || Vt;
      if (s >= n || i(this, S)) {
        i(this, N) || (h(this, N, !0), this.isPlayingPostrollVideo() ? d(this, Z, pt).call(this, (o = (l = i(this, y)) == null ? void 0 : l.postrolls) == null ? void 0 : o[this.currentPostrollIndex()]) : ((p = (E = i(this, c).banner).setBottomRightBanner) == null || p.call(E, null), (w = (g = i(this, c).banner).setLeftBanner) == null || w.call(g, null)));
        return;
      }
      s >= n || s === i(this, Q) || d(this, z, gt).call(this) && !d(this, U, nt).call(this) || (h(this, Q, s), this.currentPostrollIndex() < i(this, I).length - 1 && (d(this, R, yt).call(this, s), h(this, N, !1), i(this, x) || (i(this, c).triggerPreviewShown(), h(this, x, !0))));
    });
  }
  isPlayingPostrollVideo() {
    return i(this, P) > -1 && i(this, P) >= i(this, k) && i(this, P) < i(this, H);
  }
  setupPostrollAsVideoPlaylist(t) {
    d(this, q, ot).call(this), h(this, f, [...Array.isArray(t) ? t : []]);
    const e = [...i(this, f), ...i(this, I)];
    return h(this, k, i(this, f).length), h(this, H, i(this, k) + i(this, I).length), e;
  }
};
c = new WeakMap(), y = new WeakMap(), P = new WeakMap(), F = new WeakMap(), _ = new WeakMap(), f = new WeakMap(), $ = new WeakMap(), v = new WeakMap(), I = new WeakMap(), H = new WeakMap(), k = new WeakMap(), m = new WeakMap(), L = new WeakMap(), C = new WeakMap(), Q = new WeakMap(), Y = new WeakMap(), b = new WeakMap(), S = new WeakMap(), x = new WeakMap(), N = new WeakMap(), q = new WeakSet(), ot = function() {
  if (!(i(this, y) || !i(this, v))) {
    switch (i(this, v).type) {
      case "jad":
        h(this, y, ft(i(this, v)));
        break;
      default:
        throw new Error("Only supported for WADS");
    }
    h(this, $, typeof i(this, v).overlayActive == "boolean" ? i(this, v).overlayActive : !0), h(this, I, [...i(this, y).playlist]);
  }
}, j = new WeakSet(), ct = function() {
  var t, e;
  (e = (t = i(this, c).banner).setBottomRightBanner) == null || e.call(t, null), h(this, S, !0), i(this, c).triggerPreviewClosed();
}, A = new WeakSet(), dt = function(t, e, s, n) {
  const u = "http://www.w3.org/2000/svg", l = window.document.createElementNS(u, "svg"), o = window.document.createElementNS(u, "path");
  return l.setAttributeNS(null, "viewBox", `0 0 ${e} ${s}`), o.setAttributeNS(null, "fill", n), o.setAttributeNS(null, "d", t), l.appendChild(o), l;
}, X = new WeakSet(), ut = function(t) {
  var s;
  let e;
  if (typeof (t == null ? void 0 : t.releaseDate) == "string" && t.releaseDate.length) {
    const n = new Date(t.releaseDate);
    n.toString() !== "Invalid Date" && (e = bt(((s = i(this, v)) == null ? void 0 : s.titleReleaseDate) ?? "", {
      title: t.title,
      day: `${at(n.getDate())}`,
      month: `${at(n.getMonth() + 1)}`,
      year: `${n.getFullYear()}`
    }));
  }
  return e ?? `<strong>${t == null ? void 0 : t.title}</strong>`;
}, D = new WeakSet(), O = function() {
  return i(this, Y).cloneNode();
}, U = new WeakSet(), nt = function() {
  return i(this, P) === i(this, f).length - 1;
}, z = new WeakSet(), gt = function() {
  return i(this, P) > -1 && !this.isPlayingPostrollVideo();
}, J = new WeakSet(), vt = function(t, e) {
  var s, n;
  e === 0 && i(this, c).triggerPostrollStart(), st[e] && ((s = t == null ? void 0 : t.pixels) != null && s[st[e]]) && Ct((n = t == null ? void 0 : t.pixels) == null ? void 0 : n[st[e]]);
}, K = new WeakSet(), Pt = function() {
  var t, e, s;
  h(this, m, d(this, D, O).call(this)), h(this, b, d(this, D, O).call(this)), h(this, L, d(this, D, O).call(this)), i(this, m).classList.add(M.webediaPostrollPreview), i(this, b).classList.add(M.webediaPostrollPreviewMessage), i(this, L).classList.add(M.webediaPostrollPreviewClose), h(this, C, d(t = tt, A, dt).call(t, "m633 500 329 329c37 37 37 95 0 133a99 99 0 0 1-67 28c-23 0-49-11-66-29L500 633 171 962a99 99 0 0 1-67 28c-23 0-49-11-66-29a92 92 0 0 1 0-132l329-329L38 171a92 92 0 0 1 0-133c38-38 95-38 133 0l329 329L829 38c38-38 95-38 133 0 37 37 37 95 0 133L633 500z", 1e3, 1e3, "#FFF")), (e = i(this, C)) == null || e.classList.add(M.webediaPlayerCloseNextVideo), (s = i(this, C)) == null || s.addEventListener("click", () => d(this, j, ct).call(this), !1), i(this, C) && i(this, L).appendChild(i(this, C)), i(this, m).appendChild(i(this, b)), i(this, m).appendChild(i(this, L));
}, Z = new WeakSet(), pt = function(t) {
  var s, n;
  if (!i(this, $))
    return;
  const e = d(this, D, O).call(this);
  e.className = M.webediaPostrollCurrentlyPlaying, e.innerHTML = d(this, X, ut).call(this, t), e.addEventListener(
    "click",
    () => {
      if (i(this, c).triggerPostrollClick(), t != null && t.clickUrl)
        try {
          window.open(t == null ? void 0 : t.clickUrl);
        } catch {
        }
    },
    !1
  ), (n = (s = i(this, c).banner).setLeftBanner) == null || n.call(s, e), i(this, c).triggerCurrentlyPlayingShown();
}, R = new WeakSet(), yt = function(t) {
  var s, n, u;
  const e = Nt(((s = i(this, v)) == null ? void 0 : s.previewMessage) ?? "", `${t}`, {
    time: t,
    title: i(this, I)[this.currentPostrollIndex() + 1].title
  });
  i(this, m) === null && d(this, K, Pt).call(this), (!i(this, x) || i(this, N)) && ((u = (n = i(this, c).banner).setBottomRightBanner) == null || u.call(n, i(this, m))), i(this, b) && (i(this, b).innerHTML = e ?? "");
}, B = new WeakSet(), W = function() {
  var u, l, o, E;
  const t = this.currentPostrollIndex(), e = this.isPlayingPostrollVideo(), s = (l = (u = i(this, y)) == null ? void 0 : u.postrolls) == null ? void 0 : l[t + 1], n = (E = (o = i(this, y)) == null ? void 0 : o.postrolls) == null ? void 0 : E[t];
  (d(this, U, nt).call(this) || e) && h(this, _, s), e && h(this, F, n);
}, a(tt, A);
let rt = tt;
var T;
class kt {
  constructor() {
    a(this, T, new EventTarget());
  }
  addEventListener(t, e) {
    i(this, T).addEventListener(t, e);
  }
  removeEventListener(t, e) {
    i(this, T).removeEventListener(t, e);
  }
  dispatchEvent(t) {
    return i(this, T).dispatchEvent(t);
  }
  triggerAdClick(t) {
    this.dispatchEvent(new CustomEvent("ad-click", { detail: t }));
  }
  triggerAdEnd() {
    this.dispatchEvent(new CustomEvent("ad-end"));
  }
  triggerAdError(t) {
    this.dispatchEvent(new CustomEvent("ad-error", { detail: t }));
  }
  triggerAdPause() {
    this.dispatchEvent(new CustomEvent("ad-pause"));
  }
  triggerAdPlay() {
    this.dispatchEvent(new CustomEvent("ad-play"));
  }
  triggerAdRequest(t) {
    this.dispatchEvent(new CustomEvent("ad-request", { detail: t }));
  }
  triggerAdSkipped(t) {
    this.dispatchEvent(new CustomEvent("ad-skipped", { detail: t }));
  }
  triggerAutostartNotAllowed() {
    this.dispatchEvent(new CustomEvent("autostart-not-allowed"));
  }
  triggerBeforeComplete() {
    this.dispatchEvent(new CustomEvent("before-complete"));
  }
  triggerBuffer(t) {
    this.dispatchEvent(new CustomEvent("buffer", { detail: t }));
  }
  triggerCurrentlyPlayingShown() {
    this.dispatchEvent(new CustomEvent("currently-playing-shown"));
  }
  triggerError(t) {
    this.dispatchEvent(new CustomEvent("error", { detail: t }));
  }
  triggerHeavyAdsIntervention() {
    this.dispatchEvent(new CustomEvent("heavy-ads-intervention"));
  }
  triggerPause(t) {
    this.dispatchEvent(new CustomEvent("pause", { detail: t }));
  }
  triggerPlayerPresentationModeChange(t) {
    this.dispatchEvent(
      new CustomEvent("player-presentation-mode-change", {
        detail: t
      })
    );
  }
  triggerPlayerStart() {
    this.dispatchEvent(new CustomEvent("player-start"));
  }
  triggerPlaylistComplete() {
    this.dispatchEvent(new CustomEvent("playlist-complete"));
  }
  triggerPlaylistItem(t) {
    this.dispatchEvent(new CustomEvent("playlist-item", { detail: t }));
  }
  triggerPostrollClick() {
    this.dispatchEvent(new CustomEvent("currently-playing-banner-clicked"));
  }
  triggerPostrollStart() {
    this.dispatchEvent(new CustomEvent("postroll-start"));
  }
  triggerPreviewClosed() {
    this.dispatchEvent(new CustomEvent("next-video-closed"));
  }
  triggerPreviewShown() {
    this.dispatchEvent(new CustomEvent("next-video-shown"));
  }
  triggerQuartile(t) {
    this.dispatchEvent(new CustomEvent("quartile", { detail: t }));
  }
  triggerQuartileAd(t) {
    this.dispatchEvent(new CustomEvent("quartile-advertisement", { detail: t }));
  }
  triggerQuartilePostroll(t) {
    this.dispatchEvent(new CustomEvent("quartile-postroll", { detail: t }));
  }
  triggerReady() {
    this.dispatchEvent(new CustomEvent("ready"));
  }
  triggerResume(t) {
    this.dispatchEvent(new CustomEvent("resume", { detail: t }));
  }
  triggerSeek(t) {
    this.dispatchEvent(new CustomEvent("seek", { detail: t }));
  }
  triggerSetupError(t) {
    this.dispatchEvent(new CustomEvent("setup-error", { detail: t }));
  }
  triggerTime(t) {
    this.dispatchEvent(new CustomEvent("time", { detail: t }));
  }
  triggerVideoStart(t) {
    this.dispatchEvent(new CustomEvent("video-start", { detail: t }));
  }
}
T = new WeakMap();
class Bt extends kt {
  /**
   * Constructor to create a new Webedia Player instance.
   *
   * @param {HTMLElement} container HTML dom element.
   * @param playlist
   * @param postrollConfig
   */
  constructor(e, { playlist: s, postrollConfig: n }) {
    super();
    V(this, "banner", {});
    /**
     *  Linked player instance (dailymotion, jwplayer, ...).
     */
    V(this, "originalPlayer");
    V(this, "playlist");
    V(this, "postroll", null);
    V(this, "state");
    this.container = e, n != null && n.active && n.type === "jad" && (this.postroll = new rt(this, n)), this.state = wt.INITIALISING, this.playlist = s ?? [];
  }
  /**
   * Set any player instance which is related to webedia player.
   *
   * @param {WebediaDailymotionPlayer | WebediaJWPlayer | Player} player player instance (dailymotion, jwplayer, ...).
   */
  setPlayer(e) {
    this.originalPlayer = e;
  }
  /**
   * Returns the length of the current video (in seconds).
   */
  getDuration() {
    var e;
    return (e = this.originalPlayer) == null ? void 0 : e.getDuration();
  }
  /**
   * Warning: this function can return any instance set by a webedia module (dailymotion, jwplayer, ...).
   *
   * @returns {WebediaDailymotionPlayer | WebediaJWPlayer | Player}.
   */
  getPlayer() {
    return this.originalPlayer;
  }
  /**
   * Get Player ID.
   *
   * @return {string | null}
   */
  getPlayerId() {
    var e;
    return ((e = this.originalPlayer) == null ? void 0 : e.getPlayerId()) ?? null;
  }
  /**
   * Returns the position of the playlist.
   *
   * @return {number}
   */
  getPlaylistIndex() {
    var e;
    return ((e = this.originalPlayer) == null ? void 0 : e.getPlaylistIndex()) ?? 0;
  }
  /**
   * Returns the data used for the requested video in the playlist.
   * If no number is specified, the current playlist item's information will be returned.
   *
   * @param {number} index
   * @return {WebediaPlaylistItem}
   */
  getPlaylistItem(e) {
    var s;
    return ((s = this.originalPlayer) == null ? void 0 : s.getPlaylistItem(e)) ?? null;
  }
  /**
   * Intended to return the viewer's current position in a media file.
   *
   * @return {Number}
   */
  getPosition() {
    var e;
    return ((e = this.originalPlayer) == null ? void 0 : e.getPosition()) ?? 0;
  }
  /**
   * Get the status of the player.
   *
   * @return {string}
   */
  getState() {
    return this.state;
  }
  /**
   * Get the player’s original version tag.
   *
   * @return {string}
   */
  getVersion() {
    var e;
    return ((e = this.originalPlayer) == null ? void 0 : e.getVersion()) ?? "";
  }
  /**
   * Pause video playback.
   */
  pause() {
    var e;
    (e = this.originalPlayer) == null || e.pause();
  }
  /**
   * Start or resume video playback.
   */
  play() {
    var e;
    (e = this.originalPlayer) == null || e.play();
  }
  /**
   * Set the mute state of the player.
   *
   * @param {boolean} state
   */
  setMute(e) {
    var s;
    (s = this.originalPlayer) == null || s.setMute(e);
  }
  /**
   * Allows you to add items to the manual playlist
   * after initializing the Webedia Player.
   *
   * @param {array} playlist
   */
  setPlaylist(e) {
    this.playlist = [...this.playlist, ...e];
  }
}
const lt = /* @__PURE__ */ new WeakMap();
async function Ft(r, t, e) {
  const s = typeof r == "string" ? document.getElementById(r) : r;
  if (!s)
    return;
  if (t === null || e === null)
    return lt.get(s);
  const n = new Bt(s, e);
  return await t(n, e == null ? void 0 : e.playerOptions), lt.set(s, n), n;
}
export {
  kt as WebediaEventHandler,
  Bt as WebediaPlayer,
  Ft as default
};
